import React from 'react';
import PropTypes from 'prop-types';

import InternalMenu from '../components/internal-menu';
import ExternalMenu from '../components/external-menu';

class Page extends React.Component {
    static propTypes = {
        config: PropTypes.shape({
            menuType: PropTypes.string.isRequired,
            menuItems: PropTypes.arrayOf(
                PropTypes.shape({
                    text: PropTypes.string.isRequired,
                    url: PropTypes.string,
                }),
            ),
        }),
    };

    render() {
        const { menuType, menuItems } = this.props.config;
        return (
            <>
                {'internal' === menuType && <InternalMenu />}
                {'external' === menuType && <ExternalMenu items={menuItems} />}
            </>
        );
    }
}

export default Page;
